<template>
  <div class="cart-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="back-btn" @click="goOrderMenu">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <h2>订单明细</h2>
      <div class="header-right">
        <div class="cart-count">
          共{{ tableStore.totalCount }}件商品
        </div>
      </div>
    </div>

    <div class="cart-content">
      <div v-if="tableStore.totalCount === 0" class="empty-cart">
        <el-icon :size="80" color="#ccc">
          <ShoppingCart />
        </el-icon>
        <p class="empty-text">订单空空如也</p>
        <p class="empty-tip">快去挑选喜欢的菜品吧</p>
        <el-button 
          type="primary" 
          plain 
          @click="goOrderMenu"
          class="continue-btn"
        >
          继续点餐
        </el-button>
      </div>

      <div v-else class="cart-items-container">
        <!-- 商品列表 -->
        <div class="order-list">
          <div v-for="(order, index) in tableStore.orders" :key="order.id" class="order-card">
            <!-- 订单头部 -->
            <div class="order-header">
              <span class="order-title">第{{ tableStore.orders.length - index }}次下单({{order.isPaid ? '已支付': '未支付'}})</span>
              <span class="order-time">{{ tzDayjs.formatTime(order.orderTime) }}</span>
            </div>
            <!-- 菜品明细 -->
            <div class="order-dishes">
              <div v-for="dish in order.dishList" :key="dish.dishId" class="dish-row">
                <div class="dish-col name-col">{{ dish.name }}</div>
                <div class="dish-col quantity-col">x{{ dish.quantity }}</div>
                <div class="dish-col price-col">¥{{ dish.price.toFixed(1) }}</div>
                <div class="dish-col subtotal-col">¥{{ (dish.price * dish.quantity).toFixed(1) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部结算栏 -->
    <div class="bottom-bar" v-if="tableStore.totalCount > 0">
      <div class="bar-content">
        <div class="left-info">
          
          <span>合计:¥{{ tableStore.unpaidTotalPrice.toFixed(1) }}</span>
        </div>
        <div class="right-action">
          <el-button 
            type="primary" 
            size="large" 
            @click="goOrderMenu"
            class="bottom-btn"
          >
            继续加菜
          </el-button>
          <el-button 
            type="primary" 
            size="large" 
            @click="fnCheckout"
            class="bottom-btn"
          >
            结账
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { 
  ArrowLeft, ShoppingCart
} from '@element-plus/icons-vue'
import { useTableStore } from '@/stores/common/tableStore'
import { ElMessage } from 'element-plus'
import tzDayjs from '@/utils/dayjs';

const router = useRouter()
const tableStore = useTableStore()

// 去点菜页面
const goOrderMenu = () => {
  router.push('/orderMenu')
}

// 提交订单
const fnCheckout = () => {
  ElMessage.success('请前往吧台结账，谢谢')
  tableStore.customerCheckout()
}

onMounted( async () => {
  
  if(!tableStore.tableNo){
    router.push('/forbidden')
    ElMessage.error('请重新扫码')
    return
  }

  await tableStore.getOrderList();
})
</script>

<style scoped>
.cart-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* 页面头部 */
.page-header {
  background: white;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
}

.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  flex: 1;
  text-align: center;
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back-btn .el-icon {
  font-size: 20px;
  color: #666;
}

.header-right {
  width: 40px;
}

.cart-count {
  font-size: 12px;
  color: #999;
  text-align: right;
}

/* 购物车内容 */
.cart-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  padding-bottom: 80px; /* 为底部栏留出空间 */
}

/* 空购物车 */
.empty-cart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
  text-align: center;
}

.empty-text {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
}

.empty-tip {
  margin-top: 8px;
  font-size: 14px;
  color: #999;
  margin-bottom: 30px;
}

.continue-btn {
  width: 200px;
  border-radius: 20px;
}

/* 购物车商品列表 */
.cart-items {
  background: white;
  border-radius: 12px;
  padding: 0 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.cart-item {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}

.cart-item:last-child {
  border-bottom: none;
}

/* 底部结算栏 */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.bar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-info {
  display: flex;
  flex-direction: column;
}

.bottom-btn {
  min-width: 120px;
  border-radius: 20px;
  font-weight: 600;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  border: none;
  padding: 12px 24px;
  height: 48px;
}

/* 滚动条优化 */
.cart-content::-webkit-scrollbar {
  width: 4px;
}

.cart-content::-webkit-scrollbar-track {
  background: transparent;
}

.cart-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}

.cart-content::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .page-header {
    padding: 12px;
  }
  
  .cart-content {
    padding: 12px;
    padding-bottom: 70px;
  }
  
  .bottom-bar {
    padding: 10px 12px;
  }
  
  .bottom-btn {
    padding: 10px 20px;
    font-size: 14px;
    min-width: 100px;
    height: 44px;
  }
}

/* 表头样式 */
.table-header {
  background: #f8f9fa;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  border-bottom: 1px solid #e0e0e0;
}

.header-col {
  text-align: center;
}

.header-col:first-child {
  text-align: left;
}

.header-col:last-child {
  text-align: right;
}

/* 商品行样式 */
.item-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.item-col {
  font-size: 15px;
  padding: 0 4px;
}

.name-col {
  width: 40%;
  font-weight: 500;
  color: #333;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-col {
  width: 15%;
  color: #666;
  text-align: center;
}

.quantity-col {
  width: 10%;
  color: #666;
  text-align: center;
}

.subtotal-col {
  width: 35%;
  font-weight: 600;
  color: #ff6b6b;
  text-align: right;
}

/* 订单列表容器 */
.order-list {
  margin-top: 16px;
}

/* 每个订单卡片 */
.order-card {
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

/* 订单头部 */
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.order-title {
  font-weight: 600;
  color: #333;
}

.order-time {
  color: #999;
}

/* 订单内菜品列表 */
.order-dishes {
  padding: 0 16px;
}

/* 菜品行 */
.dish-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

.dish-row:last-child {
  border-bottom: none;
}

/* 菜品列宽度与表头一致 */
.dish-col {
  font-size: 14px;
  padding: 0 4px;
}

.dish-col.name-col {
  width: 40%;
  font-weight: 500;
  color: #333;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dish-col.price-col {
  width: 15%;
  color: #666;
  text-align: center;
}

.dish-col.quantity-col {
  width: 10%;
  color: #666;
  text-align: center;
}

.dish-col.subtotal-col {
  width: 35%;
  font-weight: 600;
  color: #ff6b6b;
  text-align: right;
}
</style>